<template>
  <confirmation-prompt
    id="expected-delivery-date-prompt"
    :show="show"
    :title="infoTitle"
    :info-text="infoText"
    :cancel-button-show="false"
    :cancel-button-text="i18n.t('/expected delivery date/prompt/nochange')"
    :confirm-button-show="false"
    :extra-wide="true"
    @cancel="cancelAction"
    @close="cancelAction"
  >
    <proposition-block
      v-show="!expectedDeliveryDateUnknownAndForced || !hideButtons"
      ref="deliveryDatePropositionBlock"
      :show-delivery-date="true"
      :show-expire-date="false"
      :show-do-not-deliver-before-date="false"
    />
    <template #buttons>
      <app-button
        v-if="!expectedDeliveryDateUnknown"
        data-qa="expected-delivery-date-prompt-change-expected"
        @click="setToExpected()"
      >
        {{ expectedDeliveryDateFormatted }}
      </app-button>
      <app-button
        v-if="!expectedDeliveryDateUnknownAndForced || !hideButtons"
        ref="expectedDeliveryDateOther"
        data-qa="expected-delivery-date-prompt-change-other"
        @click="changeDeliveryDate(null)"
      >
        {{ i18n.t('/expected delivery date/prompt/other') }}
      </app-button>
    </template>
  </confirmation-prompt>
</template>

<script>
import ConfirmationPrompt from '@/components/generic/presentational/molecules/confirmationPrompt/ConfirmationPrompt.vue'
import PropositionBlock from '@/components/generic/presentational/molecules/propositionBlock/PropositionBlock.vue'
import CheckExpectedDeliveryDate from '@/mixins/checkExpectedDeliveryDate.js'
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import { ref } from 'vue'

export default {
  // Use CheckExpectedDeliveryDate mixin with any component using this prompt
  components: {
    PropositionBlock,
    ConfirmationPrompt,
    AppButton,
  },
  mixins: [CheckExpectedDeliveryDate],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    extraWide: {
      type: Boolean,
      default: false,
    },
    hideButtons: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'confirm'],
  setup() {
    const expectedDeliveryDateOther = ref(null)
    const deliveryDatePropositionBlock = ref(null)

    return {
      expectedDeliveryDateOther,
      deliveryDatePropositionBlock,
    }
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      savedDate: null,
      labelPrefix: '/expected delivery date/prompt',
      labelErrorPrefix: '/expected delivery date/error',
    }
  },
  computed: {
    ...mapState('user', ['dealerSettings']),
    ...mapGetters({ expectedDeliveryDates: 'quote/expectedDeliveryDates' }),
    infoText() {
      let infoTextPath = ''
      if (this.expectedDeliveryDateUnknownAndForced && this.hideButtons) {
        infoTextPath = `${this.labelErrorPrefix}/text`
      } else if (this.expectedDeliveryDateUnknown) {
        infoTextPath = `${this.labelPrefix}/deliverydateunknown`
      } else {
        infoTextPath = `${this.labelPrefix}/infotext`
      }
      return this.i18n.te(infoTextPath) ? this.i18n.t(infoTextPath) : null
    },
    infoTitle() {
      if (this.expectedDeliveryDateUnknownAndForced && this.hideButtons)
        return this.i18n.t(`${this.labelErrorPrefix}/title`)
      return this.i18n.t(`${this.labelPrefix}/title`)
    },
    expectedDeliveryDateCustomer() {
      return this.expectedDeliveryDates?.ExpectedDeliveryDateCustomer
        ? moment.utc(this.expectedDeliveryDates?.ExpectedDeliveryDateCustomer)
        : null
    },
    expectedDeliveryDateFormatted() {
      return this.i18n.t(`${this.labelPrefix}/changeto`, {
        validDate: this.expectedDeliveryDateCustomer?.format('DD-MM-YYYY'),
      })
    },
  },
  watch: {
    show(newValue) {
      if (newValue) {
        this.savedDate = moment.utc(this.deliveryDate)
      }
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
    changeDeliveryDate(date) {
      if (!date) {
        this.expectedDeliveryDateOther.$el.focus()
      } else {
        this.deliveryDatePropositionBlock.changeDeliveryDate(date)
      }
      this.$emit('confirm')
      this.close()
    },
    setToExpected() {
      this.changeDeliveryDate(this.expectedDeliveryDateCustomer)
    },
    cancelAction() {
      if (this.expectedDeliveryDateUnknownAndForced) {
        this.close()
      } else if (this.savedDate?.toJSON().slice(0, 10) != this.deliveryDate) {
        this.changeDeliveryDate(this.savedDate)
      } else if (!this.expectedDeliveryDateUnknown) {
        this.setToExpected()
      } else {
        this.$emit('confirm')
        this.close()
      }
    },
  },
}
</script>

<style></style>
